(function () {
  'use strict';

  const money = (cents) => {
    try {
      return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' });
    } catch (e) {
      return (cents / 100).toFixed(2) + ' €';
    }
  };

  const COAT_HANDLES = {
    wilson: 1,
    maya: 1,
    lacfroid: 1,
    wyndham: 1,
    macmillan: 1,
    montbeliard: 1,
    'aviateur-chilliwack': 1,
    'polo-black-glossy': 1,
  };

  function bogoFromCart(cart) {
    const units = [];
    (cart.items || []).forEach((item) => {
      if (!COAT_HANDLES[item.handle]) return;
      const unit = Number(item.final_price || item.price || 0);
      for (let i = 0; i < Number(item.quantity || 1); i += 1) units.push(unit);
    });
    units.sort((a, b) => a - b);
    // 2 achetées → la 3e offerte (la moins chère)
    const free = Math.floor(units.length / 3);
    const cents = units.slice(0, free).reduce((sum, n) => sum + n, 0);
    return { free, cents, qty: units.length };
  }

  /* Drawers / modals */
  let lastFocus = null;
  function openEl(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.setAttribute('data-open', '');
    document.body.setAttribute('data-locked', '');
    const focusable = el.querySelector(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    window.requestAnimationFrame(() => focusable?.focus?.());
  }
  function closeEl(el) {
    if (!el) return;
    el.removeAttribute('data-open');
    if (!document.querySelector('[data-open]')) document.body.removeAttribute('data-locked');
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
      lastFocus = null;
    }
  }

  document.querySelectorAll('[data-open-drawer]').forEach((btn) => {
    btn.addEventListener('click', () => openEl(document.querySelector(btn.getAttribute('data-open-drawer'))));
  });
  document.querySelectorAll('[data-close]').forEach((btn) => {
    btn.addEventListener('click', () => closeEl(btn.closest('[data-open]') || document.querySelector(btn.getAttribute('data-close'))));
  });
  document.querySelectorAll('.drawer__overlay, .modal__overlay, .popup__overlay').forEach((ov) => {
    ov.addEventListener('click', () => closeEl(ov.closest('[data-open]')));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = document.querySelector('[data-open]');
    if (!open) return;
    closeEl(open);
  });

  /* Cart */
  async function fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function renderCart(cart) {
    const root = document.querySelector('[data-cart-drawer]');
    if (!root) return;
    const items = root.querySelector('[data-cart-items]');
    const empty = root.querySelector('[data-cart-empty]');
    const foot = root.querySelector('[data-cart-foot]');
    const countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    if (!cart.items.length) {
      if (items) items.innerHTML = '';
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;

    if (items) {
      items.innerHTML = cart.items
        .map((item) => {
          const variant =
            item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          return `
        <article class="cart-item" data-key="${item.key}">
          <div class="cart-item__media">
            ${item.image ? `<img src="${item.image}" alt="">` : ''}
          </div>
          <div class="cart-item__body">
            <div class="cart-item__title">${item.product_title}</div>
            ${variant ? `<div class="cart-item__variant">${variant}</div>` : ''}
            <div class="cart-item__row">
              <div class="qty">
                <button type="button" data-qty-change="${item.key}" data-delta="-1" aria-label="Moins">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-qty-change="${item.key}" data-delta="1" aria-label="Plus">+</button>
              </div>
              <div>${money(item.final_line_price)}</div>
            </div>
            <button type="button" class="cart-item__remove" data-remove="${item.key}">Retirer</button>
          </div>
        </article>`;
        })
        .join('');
    }

    const bogo = bogoFromCart(cart);
    const bogoEl = root.querySelector('[data-bogo-meter]') || root.querySelector('[data-cart-bogo]');
    if (bogoEl) {
      if (bogo.qty > 0) {
        const step = bogo.qty % 3 === 0 ? 3 : bogo.qty % 3;
        const rest = 3 - (bogo.qty % 3);
        const earned = bogo.free ? `Offre débloquée : −${money(bogo.cents)}. ` : '';
        const msg = bogo.qty % 3 === 0
          ? earned.trim()
          : earned + (rest === 1
            ? 'Plus qu’une doudoune : elle vous est offerte.'
            : `Ajoutez ${rest} doudounes, la 3e est offerte.`);
        bogoEl.hidden = false;
        bogoEl.innerHTML =
          `<span class="bogo-meter__msg">${msg}</span>` +
          `<span class="bogo-meter__track" aria-hidden="true"><span style="width:${(step / 3) * 100}%"></span></span>` +
          `<span class="bogo-meter__steps" aria-hidden="true">${['1', '2', 'Offerte']
            .map((l, i) => `<span class="${i < step ? 'is-on' : ''}">${l}</span>`)
            .join('')}</span>`;
      } else {
        bogoEl.hidden = true;
        bogoEl.textContent = '';
      }
    }

    const sub = root.querySelector('[data-cart-subtotal]');
    if (sub) {
      if (bogo.cents) {
        sub.innerHTML = `<s>${money(cart.total_price)}</s>${money(cart.total_price - bogo.cents)}`;
      } else {
        sub.textContent = money(cart.total_price);
      }
    }
    paintHold(cart.item_count);
  }

  const HOLD_MS = 15 * 60 * 1000;
  const HOLD_KEY = 'peetruss:cartHold';
  const HOLD_EXPIRED_KEY = 'peetruss:cartHoldExpired';
  let holdClearing = false;

  function holdUntil() {
    return Number(sessionStorage.getItem(HOLD_KEY) || 0);
  }
  function holdArm() {
    if (holdUntil() > Date.now()) return;
    sessionStorage.setItem(HOLD_KEY, String(Date.now() + HOLD_MS));
    sessionStorage.removeItem(HOLD_EXPIRED_KEY);
    try {
      localStorage.removeItem(HOLD_KEY);
      localStorage.removeItem(HOLD_EXPIRED_KEY);
    } catch (e) {}
  }
  function holdDisarm() {
    sessionStorage.removeItem(HOLD_KEY);
  }
  function fmtHold(ms) {
    const s = Math.max(0, Math.ceil(ms / 1000));
    const m = Math.floor(s / 60);
    const r = s % 60;
    return m > 0 ? `${m}&nbsp;min ${String(r).padStart(2, '0')}&nbsp;s` : `${r}&nbsp;s`;
  }
  function paintHold(itemCount) {
    const remaining = holdUntil() - Date.now();
    const has = itemCount > 0;
    document.querySelectorAll('[data-cart-hold]').forEach((el) => {
      const idle = el.hasAttribute('data-cart-hold-idle');
      if (!has || remaining <= 0) {
        if (idle) {
          el.hidden = false;
          el.removeAttribute('data-urgent');
          el.innerHTML =
            'Réservé <strong>15&nbsp;min</strong> à l’ajout, puis il se vide.';
        } else {
          el.hidden = true;
          el.textContent = '';
        }
        return;
      }
      el.hidden = false;
      if (remaining <= 120000) el.setAttribute('data-urgent', '');
      else el.removeAttribute('data-urgent');
      el.innerHTML = idle
        ? `Réservé encore <strong>${fmtHold(remaining)}</strong>, puis il se vide.`
        : `Votre panier vous est réservé encore <strong>${fmtHold(remaining)}</strong> — ensuite il se vide.`;
    });
    const expiredNote = document.querySelector('[data-cart-empty-hold]');
    if (expiredNote) {
      expiredNote.hidden = has || sessionStorage.getItem(HOLD_EXPIRED_KEY) !== '1';
    }
  }

  async function expireHoldIfNeeded(cart) {
    if (holdClearing) return cart;
    if (!cart.item_count) {
      holdDisarm();
      paintHold(0);
      return cart;
    }
    if (!holdUntil() || holdUntil() > Date.now()) {
      paintHold(cart.item_count);
      return cart;
    }
    holdClearing = true;
    try {
      await fetch('/cart/clear.js', { method: 'POST' });
      sessionStorage.setItem(HOLD_EXPIRED_KEY, '1');
      holdDisarm();
      cart = await fetchCart();
    } finally {
      holdClearing = false;
    }
    paintHold(0);
    return cart;
  }

  async function refreshCart(open) {
    let cart = await fetchCart();
    cart = await expireHoldIfNeeded(cart);
    renderCart(cart);
    if (open) openEl(document.querySelector('[data-cart-drawer]'));
  }

  async function addToCart(id, qty = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: qty }),
    });
    if (!res.ok) throw new Error('add failed');
    holdArm();
    await refreshCart(true);
  }

  document.addEventListener('click', async (e) => {
    const remove = e.target.closest('[data-remove]');
    if (remove) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: remove.getAttribute('data-remove'), quantity: 0 }),
      });
      await refreshCart();
      return;
    }
    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      const key = qtyBtn.getAttribute('data-qty-change');
      const delta = parseInt(qtyBtn.getAttribute('data-delta'), 10);
      const row = qtyBtn.closest('.cart-item');
      const current = parseInt(row.querySelector('.qty span').textContent, 10);
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, current + delta) }),
      });
      await refreshCart();
    }
  });

  refreshCart(false);

  /* Product form — color / size + gallery sync */
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const jsonEl = form.querySelector('[data-product-json]');
    if (!jsonEl) return;

    let product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    const optionNames = (product.options || []).map((opt) => (typeof opt === 'string' ? opt : opt.name));
    const colorName = form.getAttribute('data-color-option') || optionNames[0] || 'Couleur';
    const sizeName = form.getAttribute('data-size-option') || optionNames.find((n) => /taille|size|pointure/i.test(n)) || optionNames[1] || 'Taille';
    const root = form.closest('[data-buy-box]') || document;
    const gallery = root.querySelector('[data-product-gallery]');
    const mainImg = gallery?.querySelector('[data-gallery-main] img, [data-gallery-image]');
    const thumbs = [...(gallery?.querySelectorAll('[data-gallery-thumb]') || [])];
    const idInput = form.querySelector('[name="id"]');
    const submit = form.querySelector('[data-add]');
    const priceEl = root.querySelector('[data-product-price]');
    const compareEl = root.querySelector('[data-compare-price]');
    const colorLabel = form.querySelector('[data-color-label]');
    const sizeLabel = form.querySelector('[data-size-label]');
    const sticky = document.querySelector('[data-sticky-atc]');
    const stickyMeta = sticky?.querySelector('[data-sticky-meta]');
    const stickyPrice = sticky?.querySelector('[data-sticky-price]');
    const stickyBtn = sticky?.querySelector('[data-sticky-add]');

    const absUrl = (src) => {
      if (!src) return '';
      if (src.startsWith('//')) return window.location.protocol + src;
      return src;
    };

    const imageKey = (src) => {
      try {
        const u = new URL(absUrl(src), window.location.origin);
        return u.pathname.split('/').pop().split('?')[0];
      } catch (e) {
        return src;
      }
    };

    let selected = {};
    const urlVariant = Number(new URLSearchParams(window.location.search).get('variant'));
    const initialId = urlVariant || Number(idInput?.value);
    const initialVariant =
      product.variants.find((v) => v.id === urlVariant) ||
      product.variants.find((v) => v.available) ||
      product.variants[0];

    optionNames.forEach((opt, i) => {
      if (opt === sizeName && !urlVariant) {
        selected[opt] = undefined;
        return;
      }
      selected[opt] = initialVariant?.[`option${i + 1}`];
    });

    function optionValues(name) {
      const opt = (product.options || []).find((o) => (typeof o === 'string' ? o : o.name) === name);
      if (opt && typeof opt === 'object' && Array.isArray(opt.values) && opt.values.length) {
        return opt.values;
      }
      const idx = optionNames.indexOf(name) + 1;
      if (idx < 1) return [];
      const seen = [];
      product.variants.forEach((v) => {
        const val = v[`option${idx}`];
        if (val && !seen.includes(val)) seen.push(val);
      });
      return seen;
    }

    function findVariant() {
      return product.variants.find((v) =>
        optionNames.every((opt, i) => {
          if (selected[opt] == null || selected[opt] === '') return false;
          return v[`option${i + 1}`] === selected[opt];
        })
      );
    }

    function variantForColor() {
      const color = selected[colorName];
      const colorIdx = optionNames.indexOf(colorName) + 1;
      if (!color || colorIdx < 1) return findVariant();
      return (
        product.variants.find((v) => v[`option${colorIdx}`] === color && v.featured_image) ||
        product.variants.find((v) => v[`option${colorIdx}`] === color)
      );
    }

    function setMainImage(src, srcset) {
      if (!mainImg || !src) return;
      const next = absUrl(src);
      if (mainImg.getAttribute('src') === next) return;
      mainImg.style.opacity = '0.4';
      mainImg.onload = () => {
        mainImg.style.opacity = '1';
      };
      mainImg.src = next;
      if (srcset) mainImg.setAttribute('srcset', srcset);
      else mainImg.removeAttribute('srcset');
    }

    function imageSrcForColor(color) {
      const values = optionValues(colorName);
      const idx = values.indexOf(color);
      if (idx < 0 || !Array.isArray(product.images) || !product.images[idx]) return '';
      return product.images[idx];
    }

    function syncGallery(variant) {
      const color = selected[colorName];
      const values = optionValues(colorName);
      const colorIdx = color ? values.indexOf(color) : -1;
      let thumb =
        (color && thumbs.find((t) => t.getAttribute('data-color') === color)) ||
        (colorIdx >= 0 && thumbs.find((t) => Number(t.getAttribute('data-color-index')) === colorIdx)) ||
        (colorIdx >= 0 && thumbs[colorIdx] ? thumbs[colorIdx] : null) ||
        (variant?.featured_image?.src &&
          thumbs.find((t) => imageKey(t.getAttribute('data-src')) === imageKey(variant.featured_image.src))) ||
        null;

      if (thumb) {
        thumbs.forEach((t) => t.setAttribute('aria-current', t === thumb ? 'true' : 'false'));
        setMainImage(thumb.getAttribute('data-src'), thumb.getAttribute('data-srcset'));
        thumb.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
        return;
      }

      const src = variant?.featured_image?.src || imageSrcForColor(color);
      if (src) setMainImage(src);
    }

    function updateURL(variant) {
      if (!variant || !window.history?.replaceState) return;
      if (templateIsProduct()) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url);
      }
    }

    function templateIsProduct() {
      return document.body.classList.contains('template-product');
    }

    function nudgeSizePick() {
      const grid = form.querySelector('.size-grid');
      if (!grid) return;
      grid.classList.remove('is-nudge');
      void grid.offsetWidth;
      grid.classList.add('is-nudge');
      window.setTimeout(() => grid.classList.remove('is-nudge'), 600);
      const first = grid.querySelector('.size-btn:not([disabled])');
      first?.focus?.({ preventScroll: true });
      grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function updateUI() {
      const sizeIdx = optionNames.indexOf(sizeName) + 1;
      const needsSize = sizeIdx > 0;
      const sizePicked = Boolean(selected[sizeName]);
      const variant = findVariant();
      const waitingSize = needsSize && !sizePicked;
      const available = Boolean(variant?.available) && !waitingSize;

      if (idInput && variant) idInput.value = variant.id;

      const chooseLabel = submit?.getAttribute('data-label-choose') || 'Choisir ma taille';
      if (submit) {
        // Keep clickable when waiting for size so we can nudge the size grid.
        submit.disabled = !waitingSize && (!variant || !variant.available);
        submit.toggleAttribute('data-waiting-size', waitingSize);
        const addLabel = submit.querySelector('[data-add-label]');
        const addPrice = submit.querySelector('[data-add-price]');
        const label = waitingSize
          ? chooseLabel
          : available
            ? submit.getAttribute('data-label-add')
            : submit.getAttribute('data-label-sold');
        if (addLabel) addLabel.textContent = label;
        else submit.textContent = label;
        if (addPrice) {
          addPrice.hidden = waitingSize || !available || !variant;
          if (variant && available) addPrice.textContent = '— ' + money(variant.price);
        }
      }
      if (stickyBtn) {
        stickyBtn.disabled = !waitingSize && (!variant || !variant.available);
        stickyBtn.toggleAttribute('data-waiting-size', waitingSize);
        const stickyChoose = stickyBtn.getAttribute('data-label-choose') || chooseLabel;
        stickyBtn.textContent = waitingSize
          ? stickyChoose
          : available
            ? stickyBtn.getAttribute('data-label-add')
            : stickyBtn.getAttribute('data-label-sold');
      }
      if (stickyMeta) {
        stickyMeta.textContent = [selected[colorName], selected[sizeName]].filter(Boolean).join(' · ');
      }
      if (stickyPrice && variant) stickyPrice.textContent = money(variant.price);
      if (priceEl && variant) priceEl.textContent = money(variant.price);
      if (compareEl && variant) {
        const compare = Number(variant.compare_at_price || 0);
        if (compare > variant.price) {
          compareEl.hidden = false;
          compareEl.textContent = money(compare);
          priceEl?.closest('.buy-box__price')?.classList.add('is-sale');
        } else {
          compareEl.hidden = true;
          compareEl.textContent = '';
          priceEl?.closest('.buy-box__price')?.classList.remove('is-sale');
        }
      }
      if (colorLabel) colorLabel.textContent = selected[colorName] || '';
      if (sizeLabel) sizeLabel.textContent = selected[sizeName] || '';

      form.querySelectorAll('[data-option]').forEach((btn) => {
        const name = btn.getAttribute('data-option');
        const value = btn.getAttribute('data-value');
        btn.setAttribute('aria-pressed', selected[name] === value ? 'true' : 'false');
      });

      const colorIdx = optionNames.indexOf(colorName) + 1;
      form.querySelectorAll(`[data-option="${sizeName}"]`).forEach((btn) => {
        const value = btn.getAttribute('data-value');
        const match = product.variants.filter((v) => {
          if (sizeIdx > 0 && v[`option${sizeIdx}`] !== value) return false;
          if (colorIdx > 0 && v[`option${colorIdx}`] !== selected[colorName]) return false;
          return true;
        });
        const ok = match.some((v) => v.available);
        btn.disabled = match.length === 0 || !ok;
      });

      syncGallery(variant || variantForColor());
      if (variant) updateURL(variant);
    }

    form.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-option]');
      if (!btn || btn.disabled || !form.contains(btn)) return;
      selected[btn.getAttribute('data-option')] = btn.getAttribute('data-value');
      updateUI();
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const sizeIdx = optionNames.indexOf(sizeName) + 1;
      if (sizeIdx > 0 && !selected[sizeName]) {
        nudgeSizePick();
        return;
      }
      const variant = findVariant();
      if (!variant || !variant.available) return;
      submit.disabled = true;
      try {
        await addToCart(variant.id, 1);
      } finally {
        updateUI();
      }
    });

    stickyBtn?.addEventListener('click', () => {
      const sizeIdx = optionNames.indexOf(sizeName) + 1;
      if (sizeIdx > 0 && !selected[sizeName]) {
        nudgeSizePick();
        return;
      }
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const color = thumb.getAttribute('data-color');
        if (color && selected[colorName] !== color) {
          selected[colorName] = color;
          /* keep size if available for new color, else first available size */
          const sizeIdx = optionNames.indexOf(sizeName) + 1;
          const colorIdx = optionNames.indexOf(colorName) + 1;
          const stillOk = product.variants.some(
            (v) =>
              v[`option${colorIdx}`] === color &&
              v[`option${sizeIdx}`] === selected[sizeName] &&
              v.available
          );
          if (selected[sizeName] && !stillOk) {
            selected[sizeName] = undefined;
          }
          updateUI();
          return;
        }
        thumbs.forEach((t) => t.setAttribute('aria-current', t === thumb ? 'true' : 'false'));
        setMainImage(thumb.getAttribute('data-src'), thumb.getAttribute('data-srcset'));
      });
    });

    updateUI();
  });

  /* Sticky ATC visibility */
  const buyBox = document.querySelector('[data-buy-box]');
  const sticky = document.querySelector('[data-sticky-atc]');
  if (buyBox && sticky && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    const io = new IntersectionObserver(
      ([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      },
      { threshold: 0, rootMargin: '0px' }
    );
    io.observe(buyBox);
  }

  /* Size guide */
  document.querySelectorAll('[data-open-size-guide]').forEach((btn) => {
    btn.addEventListener('click', () => openEl(document.querySelector('[data-size-guide-modal]')));
  });

  document.querySelectorAll('[data-pdp-ship]').forEach((root) => {
    const eta = root.querySelector('[data-ship-eta]');
    const cut = root.querySelector('[data-ship-cut]');
    const frDay = (d) => d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' });
    const from = new Date();
    from.setDate(from.getDate() + 5);
    const to = new Date();
    to.setDate(to.getDate() + 14);
    if (eta) eta.textContent = `Livraison estimée entre le ${frDay(from)} et le ${frDay(to)}`;
    const tickCut = () => {
      if (!cut) return;
      const now = new Date();
      const end = new Date();
      end.setHours(18, 0, 0, 0);
      if (end - now <= 0) {
        cut.innerHTML = 'Commandé maintenant, <strong>expédié demain</strong>.';
        return;
      }
      cut.innerHTML = 'Aujourd’hui si vous commandez <strong>avant 18&nbsp;h</strong>.';
    };
    tickCut();
    window.setInterval(tickCut, 30000);
  });

  window.setInterval(() => {
    const until = holdUntil();
    if (!until) return;
    if (until <= Date.now()) {
      refreshCart(false);
      return;
    }
    const countEl = document.querySelector('[data-cart-count]');
    const n = countEl && !countEl.hidden ? parseInt(countEl.textContent, 10) || 0 : 0;
    paintHold(n);
  }, 1000);

  /* Newsletter popup — after engagement, once cookie banner is gone */
  const popup = document.querySelector('[data-newsletter-popup]');
  const privacyBanner = () =>
    document.querySelector('#shopify-pc-banner, #shopify-pc-prefs, #shopify-pc-root, [id*="shopify-pc"], [class*="shopify-pc"]');
  const introPlayed = document.getElementById('intro-root')?.classList.contains('is-playing');
  if (popup && !introPlayed && !localStorage.getItem('petrusss_popup_closed')) {
    let armed = false;
    const tryOpen = () => {
      if (armed || localStorage.getItem('petrusss_popup_closed')) return;
      if (privacyBanner() || document.querySelector('[data-open]')) {
        setTimeout(tryOpen, 800);
        return;
      }
      armed = true;
      openEl(popup);
    };
    const engage = () => {
      window.removeEventListener('scroll', engage);
      setTimeout(tryOpen, 1800);
    };
    window.addEventListener('scroll', engage, { passive: true });
    setTimeout(engage, 12000);
  }
  popup?.querySelectorAll('[data-close-popup]').forEach((btn) => {
    btn.addEventListener('click', () => {
      closeEl(popup);
      localStorage.setItem('petrusss_popup_closed', '1');
    });
  });

  /* Smooth scroll helpers */
  document.querySelectorAll('[data-scroll-buy]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const target = document.querySelector('[data-buy-box]') || document.querySelector('#coloris');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* Flow color — fond selon le coloris actif */
  document.querySelectorAll('[data-flow-color]').forEach((section) => {
    const track = section.querySelector('[data-flow-track]');
    const cards = [...section.querySelectorAll('[data-flow-card]')];
    const prev = section.querySelector('[data-flow-prev]');
    const next = section.querySelector('[data-flow-next]');
    const counter = section.querySelector('[data-flow-counter]');
    if (!track || !cards.length) return;

    let index = 0;
    let ticking = false;

    function setBg(card) {
      const bg = card.getAttribute('data-bg');
      if (bg) section.style.setProperty('--flow-bg', bg);
    }

    function goTo(i) {
      index = Math.max(0, Math.min(cards.length - 1, i));
      cards.forEach((card, n) => card.classList.toggle('is-active', n === index));
      const card = cards[index];
      const left = card.offsetLeft - (track.clientWidth - card.clientWidth) / 2;
      track.scrollTo({ left, behavior: 'smooth' });
      setBg(card);
      if (counter) counter.textContent = index + 1 + ' / ' + cards.length;
    }

    function nearestIndex() {
      const center = track.scrollLeft + track.clientWidth / 2;
      let best = 0;
      let dist = Infinity;
      cards.forEach((card, n) => {
        const c = card.offsetLeft + card.clientWidth / 2;
        const d = Math.abs(c - center);
        if (d < dist) {
          dist = d;
          best = n;
        }
      });
      return best;
    }

    prev?.addEventListener('click', () => goTo(index - 1));
    next?.addEventListener('click', () => goTo(index + 1));
    track.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const n = nearestIndex();
          if (n !== index) {
            index = n;
            cards.forEach((card, i) => card.classList.toggle('is-active', i === index));
            setBg(cards[index]);
            if (counter) counter.textContent = index + 1 + ' / ' + cards.length;
          }
          ticking = false;
        });
      },
      { passive: true }
    );

    goTo(0);
  });

  /* UGC video reel — autoplay muted in view, tap to pause/play */
  document.querySelectorAll('[data-video-reel]').forEach((root) => {
    const cards = [...root.querySelectorAll('.video-reel__card')];
    const videos = cards.map((card) => card.querySelector('[data-video]')).filter(Boolean);

    const pauseAll = (except) => {
      videos.forEach((v) => {
        if (v === except) return;
        v.pause();
        v.closest('.video-reel__card')?.classList.remove('is-playing');
      });
    };

    cards.forEach((card) => {
      const video = card.querySelector('[data-video]');
      const btn = card.querySelector('[data-video-toggle]');
      if (!video || !btn) return;

      btn.addEventListener('click', () => {
        if (video.paused) {
          pauseAll(video);
          video.play().catch(() => {});
          card.classList.add('is-playing');
        } else {
          video.pause();
          card.classList.remove('is-playing');
        }
      });
    });

    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          const card = video.closest('.video-reel__card');
          if (entry.isIntersecting && entry.intersectionRatio > 0.55) {
            pauseAll(video);
            video.muted = true;
            video.play().then(() => card?.classList.add('is-playing')).catch(() => {});
          } else {
            video.pause();
            card?.classList.remove('is-playing');
          }
        });
      },
      { threshold: [0.55], root: root }
    );
    videos.forEach((v) => io.observe(v));
  });

  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* Scroll reveal */
  const revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !reduceMotion) {
    const revealIO = new IntersectionObserver(
      (entries) => {
        let batch = 0;
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.style.setProperty('--reveal-delay', `${Math.min(batch, 4) * 80}ms`);
          entry.target.classList.add('is-visible');
          revealIO.unobserve(entry.target);
          batch += 1;
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );
    revealEls.forEach((el) => revealIO.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }

  /* Snow */
  document.querySelectorAll('canvas[data-snow]').forEach((canvas) => {
    if (reduceMotion) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    let w = 0;
    let h = 0;
    let density = Number(canvas.dataset.snow) || 1;
    let flakes = [];
    let visible = false;
    let raf = 0;
    let wind = 0;
    let targetWind = 0;
    const color = canvas.dataset.snowColor || 'rgba(255,255,255,0.9)';
    const make = (top) => ({
      x: Math.random() * w,
      y: top ? -5 : Math.random() * h,
      r: Math.random() * 2.2 + 0.6,
      s: Math.random() * 0.5 + 0.25,
      d: Math.random() * Math.PI * 2,
    });
    const setCount = () => {
      const n = Math.round(((w * h) / 9000) * density);
      while (flakes.length < n) flakes.push(make(false));
      flakes.length = Math.max(0, n);
    };
    const resize = () => {
      const r = canvas.getBoundingClientRect();
      w = r.width;
      h = r.height;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      setCount();
    };
    const tick = () => {
      if (!visible) { raf = 0; return; }
      wind += (targetWind - wind) * 0.03;
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = color;
      ctx.beginPath();
      flakes.forEach((f) => {
        f.d += 0.012;
        f.y += f.s * (1 + f.r * 0.35);
        f.x += Math.sin(f.d) * 0.35 + wind * f.r;
        if (f.y > h + 5) Object.assign(f, make(true));
        if (f.x > w + 5) f.x = -5;
        if (f.x < -5) f.x = w + 5;
        ctx.moveTo(f.x + f.r, f.y);
        ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
      });
      ctx.fill();
      raf = requestAnimationFrame(tick);
    };
    const start = () => { if (!raf) raf = requestAnimationFrame(tick); };
    canvas._setDensity = (v) => { density = v; setCount(); };
    resize();
    window.addEventListener('resize', resize);
    const host = canvas.parentElement;
    if (host && finePointer) {
      host.addEventListener('pointermove', (e) => {
        const r = host.getBoundingClientRect();
        targetWind = ((e.clientX - r.left) / r.width - 0.5) * 0.6;
      });
      host.addEventListener('pointerleave', () => { targetWind = 0; });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        if (visible) start();
      }).observe(canvas);
    } else {
      visible = true;
      start();
    }
  });

  /* Marquee — accelerates and skews with scroll speed */
  const marqueeRows = [...document.querySelectorAll('[data-marquee-row]')];
  if (marqueeRows.length && !reduceMotion) {
    let halves = [];
    const measure = () => { halves = marqueeRows.map((row) => row.scrollWidth / 2); };
    measure();
    window.addEventListener('resize', measure);
    let lastY = window.scrollY;
    let vel = 0;
    let offset = 0;
    const loop = () => {
      const y = window.scrollY;
      vel += (y - lastY - vel) * 0.1;
      lastY = y;
      offset += 0.5 + Math.min(Math.abs(vel), 60) * 0.25;
      const skew = Math.max(-10, Math.min(10, -vel * 0.35));
      marqueeRows.forEach((row, i) => {
        const half = halves[i] || 1;
        const x = offset % half;
        const tx = i % 2 ? x - half : -x;
        row.style.transform = `translate3d(${tx}px,0,0) skewX(${skew}deg)`;
      });
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  }

  /* Horizontal tracks: drag, arrows, progress, custom cursor */
  document.querySelectorAll('[data-track]').forEach((track) => {
    const root = track.closest('[data-track-root]') || track.parentElement;
    const bar = root.querySelector('[data-track-progress]');
    const prev = root.querySelector('[data-track-prev]');
    const next = root.querySelector('[data-track-next]');
    const cursor = root.querySelector('[data-cursor]');
    const isMosaic = () => track.dataset.view === 'mosaic';

    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const p = max > 0 ? track.scrollLeft / max : 1;
      if (bar) bar.style.transform = `scaleX(${Math.max(0.08, p)})`;
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft > max - 4;
    };
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    track._update = update;
    update();

    const step = () => {
      const card = track.querySelector('.look-card');
      return card ? card.getBoundingClientRect().width + 20 : 320;
    };
    const behavior = reduceMotion ? 'auto' : 'smooth';
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior }));

    if (!finePointer) return;

    let down = false;
    let moved = false;
    let startX = 0;
    let startLeft = 0;
    let lastX = 0;
    let velocity = 0;
    let momentum = 0;

    track.addEventListener('pointerdown', (e) => {
      if (e.button !== 0 || isMosaic()) return;
      cancelAnimationFrame(momentum);
      down = true;
      moved = false;
      startX = lastX = e.clientX;
      startLeft = track.scrollLeft;
      velocity = 0;
      track.classList.add('is-grabbing');
      if (cursor) cursor.classList.add('is-down');
    });
    window.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 5) moved = true;
      velocity = e.clientX - lastX;
      lastX = e.clientX;
      track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', () => {
      if (!down) return;
      down = false;
      if (cursor) cursor.classList.remove('is-down');
      if (reduceMotion) { track.classList.remove('is-grabbing'); return; }
      const glide = () => {
        velocity *= 0.94;
        track.scrollLeft -= velocity;
        if (Math.abs(velocity) > 0.4) momentum = requestAnimationFrame(glide);
        else track.classList.remove('is-grabbing');
      };
      momentum = requestAnimationFrame(glide);
    });
    track.addEventListener('click', (e) => {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    track.addEventListener('dragstart', (e) => e.preventDefault());

    if (cursor) {
      const label = cursor.querySelector('span');
      track.addEventListener('pointermove', (e) => {
        if (isMosaic()) { cursor.classList.remove('is-on'); return; }
        cursor.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
        cursor.classList.add('is-on');
        const overCard = !down && e.target.closest('.look-card');
        cursor.classList.toggle('is-view', Boolean(overCard));
        if (label) label.textContent = overCard ? 'Voir' : 'Glisser';
      });
      track.addEventListener('pointerleave', () => cursor.classList.remove('is-on'));
    }
  });

  /* 3D tilt + glare */
  if (finePointer && !reduceMotion) {
    document.querySelectorAll('[data-tilt]').forEach((card) => {
      const media = card.querySelector('.look-card__media');
      if (!media) return;
      card.addEventListener('pointermove', (e) => {
        if (card.closest('.is-grabbing')) return;
        const r = media.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        media.style.transform = `perspective(900px) rotateY(${x * 9}deg) rotateX(${-y * 9}deg) translateY(-6px)`;
        media.style.setProperty('--gx', `${(x + 0.5) * 100}%`);
        media.style.setProperty('--gy', `${(y + 0.5) * 100}%`);
      });
      card.addEventListener('pointerleave', () => { media.style.transform = ''; });
    });
  }

  /* Collection: view toggle + sort */
  document.querySelectorAll('[data-coll-view]').forEach((root) => {
    const list = root.querySelector('[data-view-target]');
    const buttons = root.querySelectorAll('[data-view-btn]');
    if (list && buttons.length) {
      const apply = (view) => {
        list.dataset.view = view;
        root.dataset.currentView = view;
        buttons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.viewBtn === view)));
        list.scrollLeft = 0;
        if (list._update) list._update();
      };
      let saved = null;
      try { saved = localStorage.getItem('peetruss-view'); } catch (e) { /* storage indisponible */ }
      if (saved === 'runway' || saved === 'mosaic') apply(saved);
      buttons.forEach((b) => b.addEventListener('click', () => {
        apply(b.dataset.viewBtn);
        try { localStorage.setItem('peetruss-view', b.dataset.viewBtn); } catch (e) { /* storage indisponible */ }
      }));
    }
    const sort = root.querySelector('[data-sort]');
    if (sort) {
      sort.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  });

  /* Story chapters: sticky visual on desktop; native swipe on mobile */
  document.querySelectorAll('[data-story]').forEach((story) => {
    const chapters = [...story.querySelectorAll('[data-chapter]')];
    const frames = story.querySelectorAll('[data-frame]');
    const counter = story.querySelector('[data-story-count]');
    const rail = story.querySelector('.story__chapters');
    const set = (i) => {
      frames.forEach((f, j) => f.classList.toggle('is-active', j === i));
      chapters.forEach((c, j) => c.classList.toggle('is-active', j === i));
      if (counter) counter.textContent = String(i + 1).padStart(2, '0');
    };

    const desktop = window.matchMedia('(min-width: 861px)');
    let io = null;
    const bindDesktop = () => {
      if (!('IntersectionObserver' in window) || io) return;
      io = new IntersectionObserver(
        (entries) => entries.forEach((e) => { if (e.isIntersecting) set(chapters.indexOf(e.target)); }),
        { rootMargin: '-45% 0px -45% 0px' }
      );
      chapters.forEach((c) => io.observe(c));
    };
    const unbindDesktop = () => {
      if (!io) return;
      io.disconnect();
      io = null;
      chapters.forEach((c) => c.classList.add('is-active'));
    };

    const syncMode = () => {
      if (desktop.matches) bindDesktop();
      else unbindDesktop();
    };
    syncMode();
    if (desktop.addEventListener) desktop.addEventListener('change', syncMode);

    if (rail) {
      rail.querySelectorAll('img').forEach((img) => {
        img.setAttribute('draggable', 'false');
      });
    }
  });

  /* Manifesto: words light up with scroll */
  const manifestos = [...document.querySelectorAll('[data-manifesto]')];
  if (manifestos.length) {
    const data = manifestos.map((m) => ({ el: m, words: m.querySelectorAll('.manifesto__word') }));
    let ticking = false;
    const paint = () => {
      ticking = false;
      const vh = window.innerHeight;
      data.forEach(({ el, words }) => {
        const r = el.getBoundingClientRect();
        const p = reduceMotion ? 1 : Math.min(1, Math.max(0, (vh * 0.8 - r.top) / (r.height + vh * 0.25)));
        const n = Math.round(p * words.length);
        words.forEach((w, i) => w.classList.toggle('is-lit', i < n));
      });
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(paint); }
    }, { passive: true });
    paint();
  }

  /* Cold scale */
  document.querySelectorAll('[data-cold]').forEach((root) => {
    const input = root.querySelector('[data-cold-input]');
    const out = root.querySelector('[data-cold-value]');
    const panels = [...root.querySelectorAll('[data-cold-level]')];
    const snow = root.querySelector('canvas[data-snow]');
    if (!input) return;
    const min = Number(input.min);
    const max = Number(input.max);
    let current = null;
    const render = () => {
      const v = Number(input.value);
      const cold = (max - v) / (max - min || 1);
      root.style.setProperty('--cold', cold.toFixed(3));
      if (out) out.textContent = `${v > 0 ? '+' : v < 0 ? '−' : ''}${Math.abs(v)}°C`;
      let best = panels[0];
      let bestDist = Infinity;
      panels.forEach((p) => {
        const d = Math.abs(Number(p.dataset.coldLevel) - v);
        if (d < bestDist) { bestDist = d; best = p; }
      });
      if (best !== current) {
        panels.forEach((p) => {
          p.classList.toggle('is-active', p === best);
          p.setAttribute('aria-hidden', String(p !== best));
        });
        current = best;
      }
      if (snow && snow._setDensity) snow._setDensity(0.05 + cold * cold * 2.6);
    };
    input.addEventListener('input', render);
    render();
  });

  /* Review deck: stacked cards, autoplay, throw to dismiss */
  document.querySelectorAll('[data-deck]').forEach((deck) => {
    let cards = [...deck.querySelectorAll('[data-deck-card]')];
    if (!cards.length) return;
    const section = deck.closest('section') || deck;
    const indexEl = section.querySelector('[data-deck-index]');
    const prevBtn = section.querySelector('[data-deck-prev]');
    const nextBtn = section.querySelector('[data-deck-next]');
    const interval = Number(deck.dataset.deckInterval) || 6;
    deck.style.setProperty('--deck-interval', `${interval}s`);
    let order = cards.map((_, i) => i);
    let busy = false;

    const syncCards = () => {
      cards = [...deck.querySelectorAll('[data-deck-card]')];
      if (order.length !== cards.length) order = cards.map((_, i) => i);
    };

    const layout = () => {
      syncCards();
      if (!cards.length) return;
      order.forEach((cardIndex, pos) => {
        const card = cards[cardIndex];
        if (!card) return;
        card.style.setProperty('--pos', pos);
        card.style.zIndex = String(cards.length - pos + 1);
        card.classList.toggle('is-front', pos === 0);
        card.setAttribute('aria-hidden', String(pos !== 0));
      });
      if (indexEl) indexEl.textContent = String(order[0] + 1).padStart(2, '0');
      const counter = section.querySelector('.reviews__counter');
      if (counter && !counter.querySelector('[data-deck-index]')) {
        /* keep */
      } else if (counter) {
        const total = String(cards.length).padStart(2, '0');
        const cur = String(order[0] + 1).padStart(2, '0');
        counter.innerHTML = `<span data-deck-index>${cur}</span> / ${total}`;
      }
    };
    layout();
    deck.addEventListener('peetruss:deck-refresh', () => {
      syncCards();
      layout();
    });
    if (cards.length < 2) return;

    const next = (dir = 1) => {
      if (busy) return;
      busy = true;
      const front = cards[order[0]];
      front.style.transform = '';
      front.classList.remove('is-dragging');
      front.style.setProperty('--throw', dir);
      front.classList.add('is-leaving');
      setTimeout(() => {
        front.classList.remove('is-leaving');
        order.push(order.shift());
        layout();
        busy = false;
      }, reduceMotion ? 0 : 420);
    };
    const prev = () => {
      if (busy) return;
      order.unshift(order.pop());
      layout();
    };
    if (nextBtn) nextBtn.addEventListener('click', () => next(1));
    if (prevBtn) prevBtn.addEventListener('click', prev);
    deck.setAttribute('tabindex', '0');
    deck.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); next(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
    });

    if (!reduceMotion) {
      deck.addEventListener('animationend', (e) => {
        if (e.animationName === 'deckProgress' && e.target.closest('.is-front')) next(1);
      });
      const pause = () => deck.classList.add('is-paused');
      const resume = () => deck.classList.remove('is-paused');
      deck.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') pause(); });
      deck.addEventListener('pointerleave', resume);
      deck.addEventListener('focusin', pause);
      deck.addEventListener('focusout', resume);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          deck.classList.toggle('is-playing', entry.isIntersecting);
        }, { threshold: 0.35 }).observe(deck);
      } else {
        deck.classList.add('is-playing');
      }
    }

    let dragCard = null;
    let startX = 0;
    let dx = 0;
    deck.addEventListener('pointerdown', (e) => {
      const card = e.target.closest('.review-card.is-front');
      if (!card || busy || e.target.closest('a')) return;
      dragCard = card;
      startX = e.clientX;
      dx = 0;
      card.classList.add('is-dragging');
      deck.classList.add('is-paused');
      try { card.setPointerCapture(e.pointerId); } catch (err) { /* capture indisponible */ }
    });
    deck.addEventListener('pointermove', (e) => {
      if (!dragCard) return;
      dx = e.clientX - startX;
      dragCard.style.transform = `translate3d(${dx}px, ${Math.abs(dx) * -0.08}px, 0) rotate(${dx * 0.06}deg)`;
    });
    const release = () => {
      if (!dragCard) return;
      const card = dragCard;
      dragCard = null;
      deck.classList.remove('is-paused');
      if (Math.abs(dx) > 80) {
        next(dx > 0 ? 1 : -1);
      } else {
        card.classList.remove('is-dragging');
        card.style.transform = '';
      }
    };
    deck.addEventListener('pointerup', release);
    deck.addEventListener('pointercancel', release);
  });

  /* Snowflake cursor + snow trail */
  if (finePointer) {
    const root = document.documentElement;
    const flake = document.createElement('div');
    flake.className = 'flake-cursor';
    flake.setAttribute('aria-hidden', 'true');
    flake.innerHTML =
      '<svg viewBox="-12 -12 24 24" width="26" height="26"><g>' +
      [0, 60, 120].map((a) =>
        `<g transform="rotate(${a})"><line x1="0" y1="-10" x2="0" y2="10"/>` +
        '<polyline points="-3,-8.5 0,-5.5 3,-8.5"/><polyline points="-3,8.5 0,5.5 3,8.5"/></g>'
      ).join('') +
      '<circle r="1.6"/></g></svg>';
    document.body.appendChild(flake);
    root.classList.add('has-flake-cursor');

    const trail = reduceMotion ? null : document.createElement('canvas');
    let tctx = null;
    let tw = 0;
    let th = 0;
    const tdpr = Math.min(window.devicePixelRatio || 1, 2);
    const particles = [];
    let trailRaf = 0;
    if (trail) {
      trail.className = 'flake-trail';
      trail.setAttribute('aria-hidden', 'true');
      document.body.appendChild(trail);
      tctx = trail.getContext('2d');
      const sizeTrail = () => {
        tw = window.innerWidth;
        th = window.innerHeight;
        trail.width = tw * tdpr;
        trail.height = th * tdpr;
        tctx.setTransform(tdpr, 0, 0, tdpr, 0, 0);
      };
      sizeTrail();
      window.addEventListener('resize', sizeTrail);
    }

    const drawMiniFlake = (p, alpha) => {
      tctx.save();
      tctx.translate(p.x, p.y);
      tctx.rotate(p.rot);
      tctx.strokeStyle = `rgba(120, 152, 186, ${alpha})`;
      tctx.lineWidth = 1;
      tctx.beginPath();
      for (let k = 0; k < 3; k += 1) {
        const a = (k * Math.PI) / 3;
        tctx.moveTo(Math.cos(a) * p.r * 2.2, Math.sin(a) * p.r * 2.2);
        tctx.lineTo(-Math.cos(a) * p.r * 2.2, -Math.sin(a) * p.r * 2.2);
      }
      tctx.stroke();
      tctx.restore();
    };
    const tickTrail = () => {
      tctx.clearRect(0, 0, tw, th);
      for (let i = particles.length - 1; i >= 0; i -= 1) {
        const p = particles[i];
        p.life -= 1 / 60;
        if (p.life <= 0) { particles.splice(i, 1); continue; }
        p.vy += 0.035;
        p.vx *= 0.97;
        p.sway += 0.08;
        p.x += p.vx + Math.sin(p.sway) * 0.3;
        p.y += p.vy;
        p.rot += 0.03;
        const alpha = Math.min(1, p.life / p.max) * 0.9;
        if (p.mini) {
          drawMiniFlake(p, alpha);
        } else {
          tctx.beginPath();
          tctx.fillStyle = `rgba(140, 172, 204, ${alpha})`;
          tctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
          tctx.fill();
          tctx.beginPath();
          tctx.fillStyle = `rgba(255, 255, 255, ${alpha})`;
          tctx.arc(p.x, p.y, p.r * 0.5, 0, Math.PI * 2);
          tctx.fill();
        }
      }
      trailRaf = particles.length ? requestAnimationFrame(tickTrail) : 0;
    };
    const spawn = (x, y, n, force) => {
      if (!trail) return;
      for (let i = 0; i < n; i += 1) {
        const angle = Math.random() * Math.PI * 2;
        const speed = Math.random() * force;
        const max = 0.7 + Math.random() * 0.8;
        particles.push({
          x, y,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed - force * 0.3,
          r: Math.random() * 1.8 + 0.8,
          life: max, max,
          sway: Math.random() * Math.PI * 2,
          rot: Math.random() * Math.PI,
          mini: Math.random() < 0.18,
        });
      }
      if (particles.length > 260) particles.splice(0, particles.length - 260);
      if (!trailRaf) trailRaf = requestAnimationFrame(tickTrail);
    };

    let mx = -100;
    let my = -100;
    let fx = -100;
    let fy = -100;
    let angle = 0;
    let lastSpawnX = 0;
    let lastSpawnY = 0;
    let hover = false;
    const interactive = 'a, button, [role="button"], label, select, summary, input[type="range"], input[type="submit"]';
    const nativeCursor = 'input:not([type="range"]):not([type="submit"]):not([type="checkbox"]):not([type="radio"]), textarea, [contenteditable="true"]';

    const follow = () => {
      fx += (mx - fx) * 0.35;
      fy += (my - fy) * 0.35;
      if (!reduceMotion) angle += hover ? 3 : 0.6;
      flake.style.transform = `translate3d(${fx}px, ${fy}px, 0) rotate(${angle}deg)`;
      requestAnimationFrame(follow);
    };
    requestAnimationFrame(follow);

    window.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse') return;
      mx = e.clientX;
      my = e.clientY;
      const t = e.target instanceof Element ? e.target : null;
      const hideForTrack = t && t.closest('[data-track]:not([data-view="mosaic"])');
      const hideForText = t && t.closest(nativeCursor);
      const hideForCookies = t && t.closest('#shopify-pc-banner, #shopify-pc-prefs, #shopify-pc-root, [id*="shopify-pc"], [class*="shopify-pc"]');
      flake.classList.toggle('is-hidden', Boolean(hideForTrack || hideForText || hideForCookies));
      hover = Boolean(t && t.closest(interactive));
      flake.classList.toggle('is-hover', hover);
      flake.classList.add('is-on');
      const dist = Math.hypot(mx - lastSpawnX, my - lastSpawnY);
      if (dist > 9) {
        spawn(mx, my, Math.min(3, Math.ceil(dist / 18)), 0.9);
        lastSpawnX = mx;
        lastSpawnY = my;
      }
    }, { passive: true });
    window.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      flake.classList.add('is-down');
      spawn(e.clientX, e.clientY, 22, 3.2);
    });
    window.addEventListener('pointerup', () => flake.classList.remove('is-down'));
    document.addEventListener('mouseleave', () => flake.classList.remove('is-on'));
  }

  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  function formatRemain(ms) {
    const d = Math.floor(ms / 86400000);
    const h = Math.floor((ms % 86400000) / 3600000);
    const m = Math.floor((ms % 3600000) / 60000);
    const s = Math.floor((ms % 60000) / 1000);
    if (d > 0) return `${d} j ${pad2(h)} h ${pad2(m)}`;
    return `${pad2(h)}:${pad2(m)}:${pad2(s)}`;
  }

  document.querySelectorAll('[data-countdown]').forEach((el) => {
    const start = Date.parse(el.getAttribute('data-countdown-start') || '');
    const end = Date.parse(el.getAttribute('data-countdown-end') || '');
    const out = el.querySelector('[data-countdown-out]');
    const prefix = el.querySelector('[data-countdown-prefix]');
    if (!out || Number.isNaN(end)) return;

    const tick = () => {
      const now = Date.now();
      if (now >= end) {
        if (prefix) prefix.textContent = 'L’offre est';
        out.textContent = 'terminée';
        return;
      }
      if (!Number.isNaN(start) && now < start) {
        if (prefix) prefix.textContent = 'Ça commence dans';
        out.textContent = formatRemain(start - now);
      } else {
        if (prefix) prefix.textContent = 'Plus que';
        out.textContent = formatRemain(end - now);
      }
    };

    tick();
    window.setInterval(tick, 1000);
  });
})();


/* Page avis — filtres + pagination */
(function () {
  const page = document.querySelector('[data-reviews-page]');
  if (!page) return;

  const cards = Array.prototype.slice.call(page.querySelectorAll('[data-rev-card]'));
  const filters = Array.prototype.slice.call(page.querySelectorAll('[data-rev-filter]'));
  const moreBtn = page.querySelector('[data-rev-more]');
  const shownLabel = page.querySelector('[data-rev-shown]');
  const step = parseInt(page.getAttribute('data-initial'), 10) || 12;
  let visible = step;
  let current = 'all';

  function apply() {
    const pool = cards.filter((c) => {
      if (current === 'all') return true;
      if (current === 'photos') return c.hasAttribute('data-has-photo');
      return c.getAttribute('data-rating') === current;
    });
    cards.forEach((c) => {
      c.hidden = true;
    });
    pool.forEach((c, idx) => {
      if (idx < visible) c.hidden = false;
    });
    const showing = Math.min(visible, pool.length);
    if (shownLabel) {
      shownLabel.textContent =
        showing + ' avis affiché' + (showing > 1 ? 's' : '') + ' sur ' + pool.length;
    }
    if (moreBtn) moreBtn.hidden = showing >= pool.length;
  }

  filters.forEach((btn) => {
    btn.addEventListener('click', () => {
      filters.forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      current = btn.getAttribute('data-rev-filter');
      visible = step;
      apply();
    });
  });

  if (moreBtn) {
    moreBtn.addEventListener('click', () => {
      visible += step;
      apply();
    });
  }

  apply();

  const lb = document.querySelector('[data-rev-lb]');
  if (lb) {
    const lbImg = lb.querySelector('[data-rev-lb-img]');
    const open = (src) => {
      lbImg.src = src;
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
    };
    const close = () => {
      lb.hidden = true;
      lbImg.src = '';
      document.body.style.overflow = '';
    };
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-rev-photo]');
      if (btn) open(btn.getAttribute('data-rev-photo'));
      if (e.target === lb || e.target.closest('[data-rev-lb-close]')) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !lb.hidden) close();
    });
  }

  const form = document.querySelector('.revs-form');
  if (form && form.querySelector('.revs-form__success')) {
    form.scrollIntoView({ block: 'center' });
  }
})();
